import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import DashboardContent from './cabinet/DashboardContent';
import SettingsContent from './cabinet/SettingsContent';
import UpcomingContent from './cabinet/UpcomingContent';
import './Cabinet.css';

const Cabinet = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { user, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('dashboard');

  const handleLogout = async () => {
    await logout();
    history.push('/');
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'settings':
        return <SettingsContent />;
      case 'upcoming':
        return <UpcomingContent />;
      case 'dashboard':
      default:
        return <DashboardContent />;
    }
  };

  return (
    <div className="cabinet-page">
      <div className="cabinet-container">
        <header className="cabinet-header">
          <nav className="cabinet-tabs">
            <button
              className={`cabinet-tab ${activeTab === 'dashboard' ? 'active' : ''}`}
              onClick={() => setActiveTab('dashboard')}
            >
              {t('cabinet.tabs.dashboard') || 'Обзор'}
            </button>
            <button
              className={`cabinet-tab ${activeTab === 'settings' ? 'active' : ''}`}
              onClick={() => setActiveTab('settings')}
            >
              {t('cabinet.tabs.settings') || 'Настройки'}
            </button>
            <button
              className={`cabinet-tab ${activeTab === 'upcoming' ? 'active' : ''}`}
              onClick={() => setActiveTab('upcoming')}
            >
              {t('cabinet.tabs.upcoming') || 'Скоро'}
            </button>
          </nav>

          <div className="cabinet-header-right">
            {user?.email && (
              <p className="cabinet-subtitle">
                {user.email}
              </p>
            )}
            <button
              className="cabinet-tab cabinet-tab-logout"
              onClick={handleLogout}
            >
              {t('landing.logout') || 'Выйти'}
            </button>
          </div>
        </header>

        <main className="cabinet-content">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default Cabinet;

